// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3luWd","topBottomGutter":"Layout_topBottomGutter__2GRGs"};